import React, { FC } from 'react';
import { Box, Grid, Paper } from '@mui/material';
import UsageOverview from 'components/usage/usage-overview.component';

/**
 * DD-3641: storage usage for clinic organizations. Clinics have no settings
 * page yet, so this is a standalone page; the route is hidden behind the
 * REACT_APP_ENABLE_CLINIC_USAGE flag until clinic-facing usage is launched.
 * The backend query is scoped to the caller's organization, so this renders a
 * clinic's own figures with no clinic-specific wiring.
 */
const ClinicUsage: FC = () => {
    return (
        <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} sm={8}>
                <Paper>
                    <Box p={2}>
                        <UsageOverview />
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default ClinicUsage;
